import CreatorSavedResponsesModalComponent from "./CreatorSavedResponsesModalComponent";

export default CreatorSavedResponsesModalComponent;
